/**
 * Filtros da listagem do catálogo de agentes nocivos: busca por nome, CAS ou código do eSocial
 * e a situação do agente. Aplicam na hora, sem botão.
 */
import React from 'react';
import { InlineFilterBar, InlineSelect } from '../../../components/common';
import type { InlineSelectOption } from '../../../components/common';
import { useFilterState } from '../../../hooks/useFilterState';

export interface HazardousAgentFiltersData {
  searchTerm: string;
  status: string;
}

export const HAZARDOUS_AGENT_FILTERS_DEFAULT: HazardousAgentFiltersData = {
  searchTerm: '',
  status: '',
};

const STATUS_OPTIONS: InlineSelectOption[] = [
  { value: 'ACTIVE', label: 'Ativos' },
  { value: 'INACTIVE', label: 'Inativos' },
];

const STATUS_LABELS: Record<string, string> = { ACTIVE: 'Ativos', INACTIVE: 'Inativos' };

interface Props {
  onFilter: (filters: HazardousAgentFiltersData) => void;
  loading?: boolean;
  total?: number;
}

export const HazardousAgentFilters: React.FC<Props> = ({ onFilter, loading = false, total }) => {
  const { filters, setFilter, clearAll, activeChips } = useFilterState(HAZARDOUS_AGENT_FILTERS_DEFAULT, {
    onFilter,
    applyOnMount: true,
    live: true,
    labels: { status: 'Situação' },
    formatValue: { status: (v: string) => STATUS_LABELS[v] ?? v },
  });

  return (
    <InlineFilterBar
      searchPlaceholder="Buscar por nome, número CAS ou código do eSocial"
      searchValue={filters.searchTerm}
      onSearchChange={(v) => setFilter('searchTerm', v)}
      resultCount={total}
      resultNoun="agentes"
      chips={activeChips}
      onClearAll={clearAll}
      loading={loading}
    >
      <InlineSelect
        label="Situação"
        value={filters.status}
        options={STATUS_OPTIONS}
        onChange={(v) => setFilter('status', v)}
        emptyLabel="Todos"
        minWidth={160}
      />
    </InlineFilterBar>
  );
};

export default HazardousAgentFilters;
